import React from 'react';
import PropTypes from 'prop-types';

//styles
import { FormGroup } from 'components/styled/Form.styled';

//components
import FormLabel from '../Label';

import { PhoneInputField } from './index.styled';

const PhoneField = ({
  name,
  label,
  setFieldValue,
  disabled,
  value,
  required,
  readOnly,
  mb,
  isValid,
}) => {
  return (
    <FormGroup mb={mb}>
      <FormLabel label={label} name={name} disabled={disabled} isRequired={required} />
      <PhoneInputField
        name={name}
        isValid={isValid}
        country="hr"
        onChange={e => setFieldValue(name, e)}
        disabled={disabled}
        inputProps={{ name: name, readOnly: readOnly, required: required }}
        value={value}
        defaultMask="..-...-...."
        alwaysDefaultMask
      />
    </FormGroup>
  );
};

PhoneField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  mb: PropTypes.string,
  isValid: PropTypes.bool,
};

export default PhoneField;
